module.exports = __webpack_public_path__ + "static/media/f_utility_bill.9ea99a9b.svg";